import { setSelectedAssets } from '@/store/slices/assetsPreviewSlice/assetsPreviewSlice';
import { useAppFilters, useActiveTab } from '@/hooks';
import { useActiveAssetsType } from '@/hooks/shared/useActiveAssetsType';
import { ASSETS_PREVIEW, FILTER_PARAMS } from '@/types/shared/navigation-tabs.enums';
import { Asset } from '@/types/models/assets.types';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { sortComponentsByName } from '../../AssetsStudioPage/SidePane/ComponentSelector/util';

export function useAssetsSelector({ assets }: { assets: any }) {
  const { setFilters, selectedAsset } = useAppFilters();
  const { isMaintenance } = useActiveTab();
  const sortedAssets = useMemo(() => sortComponentsByName(assets, 'asset_name'), [assets]);
  const { isMobileAsset } = useActiveAssetsType();
  const dispatch = useDispatch();

  const filteredAssets = useMemo(
    () =>
      sortedAssets.filter((el: Asset) => {
        const activeAssetType = isMobileAsset ? 'mobile' : 'fixed';
        return el.asset_category === activeAssetType;
      }),
    [sortedAssets, isMobileAsset]
  );

  const defaultVal = useMemo(() => {
    return { assets: [filteredAssets?.[0]?.asset_id] };
  }, [filteredAssets, selectedAsset]);

  const handleFilterUpdate = (data: any) => {
    const selectedId = data?.assets?.[0];
    const item = filteredAssets?.find((el: any) => el.asset_id === selectedId);
    if (item && selectedAsset !== selectedId) {
      setFilters({ [FILTER_PARAMS.SELECTED_ASSET]: selectedId });
      dispatch(setSelectedAssets({ id: selectedId, data: [item] }));
    } else if (selectedId === ASSETS_PREVIEW.ALL_ASSETS && selectedAsset !== ASSETS_PREVIEW.ALL_ASSETS) {
      setFilters({ [FILTER_PARAMS.SELECTED_ASSET]: ASSETS_PREVIEW.ALL_ASSETS });
      dispatch(setSelectedAssets({ id: ASSETS_PREVIEW.ALL_ASSETS, data: filteredAssets }));
    }
  };

  const assetsList = useMemo(() => {
    const tmp = filteredAssets.map((el: any) => ({
      id: el.asset_id,
      name: el.asset_ui_name,
      ...el,
    }));

    const baseMenuItems = [
      // { id: ASSETS_PREVIEW.ALL_ASSETS, name: 'Show All Assets', counter: filteredAssets?.length || 0, disabled: true },
      // { id: ASSETS_PREVIEW.UNASSIGNED, name: 'Unassigned', counter: 0 },
      ...tmp,
    ];

    const units = Array.from(new Set(tmp.map((el: any) => el.unit_ui_name))).filter(Boolean);

    return {
      components: [
        {
          menuLabel: 'assets',
          menuItems: baseMenuItems.filter((el) =>
            isMaintenance
              ? el.id !== ASSETS_PREVIEW.UNASSIGNED || el.counter > 0
              : el.id !== ASSETS_PREVIEW.ALL_ASSETS && el.id !== ASSETS_PREVIEW.UNASSIGNED
          ),
        },
      ],
      units,
    };
  }, [filteredAssets, isMaintenance]);

  return {
    items: assetsList?.components,
    uiUnits: assetsList?.units,
    groupKey: null,
    defaultVal,
    cardTitle: '',
    handleFilterUpdate,
    variant: 'maintenance',
    onItemClick: () => {},
  };
}
